import mitt from 'mitt'
import type { KeyboardNavigationEvents } from '../model/events'

export const keyboardNavigationEventBus = mitt<KeyboardNavigationEvents>()
